export default "__VITE_ASSET__BFDJiT8f__"